import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'functionPure',
    standalone: false
})
export class FunctionPurePipe<T> implements PipeTransform {
    transform(value: T, func: (value: T) => string) {
        return func(value);
    }
}